import React from "react";

import { Flex, Box, Text, HStack } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import Information from "../Information";
import MultipleInformation from "../../../pages/ServicosAcolhimento/Visualizar/MultipleInformation";

import InformationPanel from "../../../pages/ServicosAcolhimento/PanelBase/Information";
import { mascaraCNPJ, cep as cepMask } from "../../../utils/masks";
import { format } from "date-fns";

export const DadosPrincipais = ({ data, dataPerfil, previewLayout }) => {
  return data ? (
    <HStack alignItems="flex-start">
      <Box
        display="block"
        bgColor="#E5EFEF"
        px="10px"
        py="20px"
        borderRadius="16px"
        w="100%"
        minW={"200px"}
        maxW={"240px"}
      >
        <Flex flexDir="column" alignItems="center" justifyContent="center">
          {data?.logomarca ? (
            <img
              src={data?.linkImagem + "?" + Date.now()}
              alt="Logomarca"
              style={{
                width: "135px",
                height: "135px",
                borderRadius: "50%",
              }}
            />
          ) : (
            <Box boxSize="135px" bgColor="#C4C4C4" borderRadius="full" />
          )}
          <Text
            mt="10px"
            color="#000"
            fontWeight={700}
            fontSize="16px"
            lineHeight="21.6px"
          >
            {data?.nomeFantasia}
          </Text>
        </Flex>
        <Box display="block">
          <InformationPanel
            title="Status:"
            information={
              data?.desativado === "S"
                ? "Desativado"
                : data?.suspenso === "S"
                ? "Suspenso"
                : "Ativo"
            }
            mt={30}
          />
          <InformationPanel
            title="Natureza:"
            information={
              data?.naturezaServico === "publica" ? "Pública" : "Privada"
            }
          />
          <InformationPanel
            title="Regime:"
            information={
              data?.tipoServicoAcolhimento?.regime === "SAI"
                ? "Serviço de Acolhimento Institucional"
                : "Serviço de Acolhimento Familiar"
            }
          />
          {data?.tipoServicoAcolhimento.modalidade.toUpperCase() !==
            "NÃO SE APLICA" && (
            <InformationPanel
              title="Modalidade:"
              information={data?.tipoServicoAcolhimento?.modalidade}
            />
          )}
          <InformationPanel
            title="Promotoria:"
            information={data?.promotoria.nome}
          />
          <InformationPanel
            title="Vara da Infância:"
            information={data?.varaInfancia.nome}
          />
          <InformationPanel
            title="Capacidade de Atendimento:"
            information={
              dataPerfil ? dataPerfil?.capacidadeAcolhimento : "Não informado."
            }
          />
          <InformationPanel
            title="Vagas Ocupadas:"
            information={
              dataPerfil?.servicoAcolhimento?.vagasOcupadas || "Não informado."
            }
          />
          <InformationPanel
            title="Vagas Disponíveis:"
            information={
              dataPerfil?.capacidadeAcolhimento -
                dataPerfil?.servicoAcolhimento?.vagasOcupadas ||
              "Não informado."
            }
          />
          <InformationPanel
            title="Data da Criação:"
            information={
              data.dataCriacao
                ? format(new Date(data.dataCriacao), "dd/MM/yyyy")
                : ""
            }
          />
          <InformationPanel
            title="Data da Última Atualização:"
            information={
              data.dataUltimaAtualizacao
                ? format(new Date(data.dataUltimaAtualizacao), "dd/MM/yyyy")
                : ""
            }
          />
        </Box>
      </Box>
      <Box display="block" flex={previewLayout ? "auto" : ""}>
        <Group
          bgColor="#E5EFEF"
          title="Promotoria e Vara da Infância e Juventude"
          mt="0px"
          py="12px"
          mtDivider="5px"
        >
          <Information
            title="Promotoria:"
            information={data?.promotoria.nome}
            mt="10px"
          />
          <Information
            title="Vara da Infância:"
            information={data?.varaInfancia.nome}
            mt="10px"
          />
          <Information
            title="Procedimento de inclusão:"
            information={data?.numeroInclusao}
            mt="10px"
          />
          {data?.dataDesativacao && (
            <Information
              title="Procedimento de desativação:"
              information={data?.procedimentoDesativacao}
            />
          )}
        </Group>
        <Group
          bgColor="#E5EFEF"
          title="Caracterização do Serviço de Acolhimento"
          py="12px"
          mtDivider="5px"
        >
          <Information
            title="Natureza:"
            information={
              data?.naturezaServico === "publica" ? "Pública" : "Privada"
            }
            mt="10px"
          />
          <Information
            title="Regime:"
            information={
              data?.tipoServicoAcolhimento?.regime === "SAI"
                ? "Serviço de Acolhimento Institucional"
                : "Serviço de Acolhimento Familiar"
            }
            mt="10px"
          />
          {data?.tipoServicoAcolhimento.modalidade.toUpperCase() !==
            "NÃO SE APLICA" && (
            <Information
              title="Modalidade:"
              information={data?.tipoServicoAcolhimento?.modalidade}
              mt="10px"
            />
          )}
        </Group>

        <Flex>
          <Group
            bgColor="#E5EFEF"
            title="Identificação do Serviço de Acolhimento"
            py="12px"
            mtDivider="5px"
          >
            <Information
              title="Nome Fantasia:"
              information={data?.nomeFantasia}
              mt="10px"
            />
            <Information
              title="Razão Social:"
              information={data?.razaoSocial}
              mt="10px"
            />
            <Information
              title="CNPJ:"
              information={data?.cnpj ? mascaraCNPJ(data?.cnpj) : ""}
              mt="10px"
            />
            <Information title="Site:" information={data?.site} mt="10px" />
            <Information
              title="Estado:"
              information={data?.endereco?.estado?.nome}
              mt="10px"
            />
            <Information
              title="Cidade:"
              information={data?.endereco?.municipio?.nome}
              mt="10px"
            />
            <Information
              title="Bairro:"
              information={
                data?.endereco?.bairro ? data?.endereco?.bairro?.nome : ""
              }
              mt="10px"
            />
            <Box className="break-page" py="20px">
              <Information
                title="Logradouro:"
                information={data?.endereco?.logradouro}
                mt="10px"
              />

              <Information
                title="Número:"
                information={
                  data?.endereco?.numeroResidencia !== 0
                    ? data?.endereco?.numeroResidencia
                    : ""
                }
                mt="10px"
              />
              <Information
                title="CEP:"
                information={
                  data?.endereco?.cep ? cepMask(data?.endereco?.cep) : ""
                }
                mt="10px"
              />
              <Information
                title="Complemento:"
                information={data?.endereco?.complemento}
                mt="10px"
              />
              <Information
                title="Ponto de referência:"
                information={data?.endereco?.pontoReferencia}
                mt="10px"
              />
              <MultipleInformation
                title="Órgão/Entidade Mantenedora:"
                informations={data?.mantenedoras?.map(
                  (mantenedora) => mantenedora.nome,
                )}
                mt="10px"
              />
            </Box>
          </Group>
        </Flex>

        <Box className="break-page">
          <Group
            bgColor="#E5EFEF"
            title="Informações de Contato"
            py="12px"
            mtDivider="5px"
          >
            <MultipleInformation
              title="Telefone (s):"
              informations={data?.telefones.map(
                (telefone) =>
                  `${telefone.telefone}${
                    telefone.descricao !== "" ? ` (${telefone.descricao})` : ""
                  }`,
              )}
              mt="10px"
            />
            <MultipleInformation
              title="E-mail (s):"
              informations={data?.emails.map(
                (email) =>
                  `${email.email}${
                    email.descricao !== "" ? ` (${email.descricao})` : ""
                  }`,
              )}
              mt="10px"
            />
          </Group>
        </Box>
      </Box>
    </HStack>
  ) : (
    <Box display="block">
      <Group
        bgColor="#E5EFEF"
        title="Dados principais"
        mt="15px"
        py="12px"
        mtDivider="5px"
      />
    </Box>
  );
};
